import { compose } from "ramda";
import React from "react";
import { FormattedNumber } from "react-intl";
import { currencyReplacer } from "./utils/formatCurrency";
import splitFormattedCurrency from "./utils/splitFormattedCurrency";
const renderCurrency = (hideDecimalsForIntegers, styleSymbol, currency = "") => (formattedCurrency) => {
  if (!hideDecimalsForIntegers && !styleSymbol) {
    return formattedCurrency;
  }
  const { prefix, units, decimals, suffix } = splitFormattedCurrency(formattedCurrency);
  const hideDecimals = hideDecimalsForIntegers && decimals.substring(1) === "00";
  const currencyStyles = styleSymbol && styleSymbol.currencyCode === currency ? styleSymbol.style : void 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, prefix && /* @__PURE__ */ React.createElement("span", {
    className: currencyStyles
  }, prefix), units, !hideDecimals && /* @__PURE__ */ React.createElement("span", null, decimals), suffix && /* @__PURE__ */ React.createElement("span", {
    className: currencyStyles
  }, suffix));
};
const wrapSpan = (testId) => (value) => /* @__PURE__ */ React.createElement("span", {
  "data-test": testId
}, value);
const FormattedCurrency = (props) => {
  const {
    testId,
    hideDecimalsForIntegers,
    styleSymbol,
    hideSymbol,
    currency,
    children: transformFormattedCurrency = (value) => value
  } = props;
  const children = compose(wrapSpan(testId), renderCurrency(hideDecimalsForIntegers, styleSymbol, currency), currencyReplacer(currency, hideSymbol), transformFormattedCurrency);
  return /* @__PURE__ */ React.createElement(FormattedNumber, {
    style: "currency",
    ...props
  }, children);
};
var FormattedCurrency_default = FormattedCurrency;
export {
  FormattedCurrency_default as default
};
